<template>
  <div class="container game_container">
    <div class="content-box">
      <div class="banner"></div>
      <div class="content">
        <div class="info" v-for="(item, i) in array" :key="i">
          <div class="img-box">
            <img :src="item.imgPath" alt="" />
          </div>
          <div class="desc-box">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="btn">
              <img src="../../assets/img/ljxq.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <aboutUs />
  </div>
</template>

<script>
import aboutUs from "../../components/contact";
export default {
  components: { aboutUs },
  data() {
    //这里存放数据
    return {
      array: [
        {
          id: 0,
          imgPath: require("../../assets/img/wj.jpg"),
          title: "无尽",
          desc:
            "《无尽》游戏选用清晰独特的幻想题材，在延续经典的PVP、PVE玩法的基础上，加入革新的战斗模式，激爽畅快的竞技快感，让人欲罢不能。",
        },
        {
          id: 1,
          imgPath: require("../../assets/img/syz.jpg"),
          title: "圣妖传",
          desc:
            "《圣妖传》是极峰网络清新唯美Q版MMO新作，以东方仙侠为背景，拥有跌岩起伏的剧情，绚丽的职业特色技能，独特创新的游戏成长系统，丰富多彩的任务以及各具特色的游戏玩法，带你体验一段激情四溢的仙侠战斗之旅。",
        },
        {
          id: 2,
          imgPath: require("../../assets/img/my.jpg"),
          title: "魔域",
          desc:
            "《魔域》为动漫及网剧IP原创手游，是一款世界观宏大的穿越题材手游，除此之外还加入众多奇趣幻想的要素，血族，天帝等中西要素完美交融。缔造专属现代都市之人的趣味冒险。画面精美清晰，带有卡通清新风格以穿越为题材，游戏的剧情内容丰富，世界观架构宏大，人物造型也十分精致。转轮回，前生今世纠缠不休；曲折历程，追寻迷惘之中的模糊记忆；真相显现，穿越时空的冒险旅程。",
        },
        {
          id: 3,
          imgPath: require("../../assets/img/syz1.jpg"),
          title: "圣妖传",
          desc:
            "《圣妖传》是一款排兵布阵为题材的回合制策略手游，将经典的策略玩法和大型网游的角色扮演完美结合，搭配独特的兵将招募系统、站纹进阶系统、列阵战斗系统，让玩家在征服乱世的同时可以享受战术运用带来的快感。游戏将玩家代入硝烟四起的战争时代，在征战十三州这个 群雄逐鹿的世界里扮演一名城池君主，担负起拯救乱世苍生、统一天下的大任，屯粮养兵。保卫城池、征战四方，让天下万民臣服于你！",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
